import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import ZoneCard from "@/components/feature/ZoneCard";
import { zones } from "@/mocks/zones";

export default function FeaturedZones() {
  return (
    <section aria-labelledby="zones-title" className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          id="zones-title"
          eyebrow="Zones"
          title="热门专区合集"
          description="按内容方向划分的专区入口，每个专区下把所有相关期数收在一处，点进去就是一整块内容。"
          action={
            <Link
              to="/zones"
              className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-foreground-300 text-sm text-foreground-900 whitespace-nowrap cursor-pointer hover:border-foreground-900 transition-colors"
            >
              查看全部专区
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {zones.map((zone, index) => (
            <Reveal key={zone.id} delay={index * 70}>
              <ZoneCard zone={zone} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}